module.exports = __webpack_public_path__ + "img/ic_star.f9d4d19c.svg";